import { isString, filter, toNumber } from 'lodash-es';

const shopifyCdn = {
  /**
   * Get image from Shopify CDN and transform it
   * Docs: https://www.shopify.com/partners/blog/img-url-filter
   *
   * @param {String|*} url
   * @param {String|Number} width
   * @param {String|Number} height
   * @param {String} crop Valid values: "top" | "center" | "bottom" | "left" | "right"
   * @param {String|Number} scale Valid values: 2 | 3
   * @returns {String}
   */
  getImage(url, width = 0, height = 0, crop = '', scale = '') {
    const validCrops = ['top', 'center', 'bottom', 'left', 'right'];
    const validScales = ['2', '3'];
    const validCdnHosts = ['cdn.shopify.com'];

    if (url && isString(url)) {
      // Remove existing thumbnail suffix, if available
      // "https://cdn.shopify.com/s/files/1/0594/9607/1343/products/Image202048x2048_97b87677-a36f-49b6-acf3-cf5f74afef4b_120x120.jpg?v=1655969878"
      // Important: don't remove suffix that is part of original image name, e.g. https://cdn.shopify.com/s/files/1/0343/7389/files/JJ_2045_FATHERSDAY_ECRM_1200X90011_392x392.jpg?v=1683798360
      url = url.replace(/_\d*x\d*\./, '.');

      // Check if URL is using Shopify CDN host
      const urlObj = new URL(url);
      if (validCdnHosts.indexOf(urlObj.host) !== -1) {
        // Prepare suffix
        const suffix = [];

        const inject = filter([
          width && height && toNumber(width) && toNumber(height)
            ? `${width}x${height}`
            : false,
          crop &&
            isString(crop) &&
            validCrops.indexOf(crop) !== -1 &&
            `crop_${crop}`
        ]);
        if (inject.length) {
          suffix.push(`_${inject.join('_')}`);
        }

        if (scale && validScales.indexOf(`${scale}`) !== -1) {
          suffix.push(`@${scale}x`);
        }

        if (suffix.length) {
          return (
            urlObj.origin +
            urlObj.pathname.replace(/.([a-z]*)$/i, `${suffix.join('')}.$1`) +
            urlObj.search
          );
        }
      }
    }

    return url || '';
  }
};

export default shopifyCdn;
